// eslint-disable-next-line no-restricted-imports
import isNil from 'lodash/isNil';
import React from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Try `npm install @types/universal-rx-request` if i... Remove this comment to see the full error message
// eslint-disable-next-line no-restricted-imports
import rxRequest from 'universal-rx-request';

import ReporterForm from './ReporterForm';
import ReportModalFailure from './ReportModalFailure';
import ReportModalSuccess from './ReportModalSuccess';

const REQUEST_STATES = {
  NONE: 'none',
  ...rxRequest.STATUS,
};

type Props = {
  categories?: Array<{
    key: string;
    value: string;
  }>;
  modalTitle: string;
  onCancel?: (...args: any[]) => any;
  onExit: (...args: any[]) => any;
  onSubmit: (...args: any[]) => any;
  optional?: boolean;
  // TODO: PropTypes.oneOf(Object.values(REQUEST_STATES))
  submitRequestState: any;
  successMessage?: React.ReactNode;
};

const ReportModal: React.FC<Props> = (props) => {
  const {
    categories,
    modalTitle,
    onExit,
    onSubmit,
    optional = false,
    submitRequestState,
    successMessage,
  } = props;

  let dataCy;
  let content;
  const onCancel = isNil(props.onCancel) ? onExit : props.onCancel;

  let onClose;

  switch (submitRequestState) {
    case REQUEST_STATES.NONE:
    case REQUEST_STATES.FETCHING:
      onClose = onCancel;
      dataCy = 'report-container';
      content = (
        <ReporterForm
          onClose={onClose}
          onSubmit={onSubmit}
          submitRequestState={submitRequestState}
          modalTitle={modalTitle}
          categories={categories}
          optional={optional}
        />
      );
      break;
    case REQUEST_STATES.SUCCESS:
      onClose = onExit;
      dataCy = 'report-success-container';
      content = (
        <ReportModalSuccess onClose={onClose} successMessage={successMessage} />
      );
      break;
    case REQUEST_STATES.ERROR:
      onClose = onExit;
      dataCy = 'report-failure-container';
      content = <ReportModalFailure submitFeedback={onSubmit} />;
      break;
    default:
      throw new Error(
        `submitRequestState: ${submitRequestState} not recognized`,
      );
  }

  return (
    <div data-cy={dataCy} id="report-exercise">
      {content}
    </div>
  );
};

export default ReportModal;
export { REQUEST_STATES };
